(function (Survey) {

    var SurveyModel = {
      	showCompletedPage: false,
        showProgressBar: "bottom",
        requiredText: "",
        pages: [
            {
                questions: [
                  	{
                      type: "html",
                      hasInput: false,
                      name: "info",
                      html: "<h5 class='earthbar-survey__title--intro'>hello</h5><h5 class='earthbar-survey__subtitle--intro'>earthling</h5>"
                    },
                    {
                        type: "text",
                        name: "clientName",
                        title: "What is your name?",
                        titleLocation: "hidden",
                        placeHolder: "Write your name here",
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                    {
                        type: "imagepicker",
                        name: "approachNutrition",
                        title: "How do you feel when you approach nutrition?",
                        choices: [
                            {
                                text: "Knowledgeable",
                                imageLink: "//cdn.shopify.com/s/files/1/0003/8240/2607/t/20/assets/icon-sunglasses_small.png?v=133982818080771195431631638287",
                                value: "a"
                            },
                            {
                                text: "Curious",
                              	imageLink: "//cdn.shopify.com/s/files/1/0003/8240/2607/t/20/assets/icon-happy_small.png?v=149080414461094495361631638350",
                                value: "b"
                            },
                            {
                                text: "Skeptical",
                                imageLink: "//cdn.shopify.com/s/files/1/0003/8240/2607/t/20/assets/icon-serious_small.png?v=123799191106779745331631638261",
                                value: "c"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--info'></div>"
                    },
                    {
                        type: "checkbox",
                        name: "healthInformation",
                        title: "Where do you get your health information?",
                        choices: [
                            {
                                text: "Friends",
                                value: "a1"
                            },
                            {
                                text: "Brands I love",
                                value: "b1"
                            },
                            {
                                text: "Books and Scientific Studies",
                                value: "a2"
                            },
                            {
                                text: "Email Newsletters",
                                value: "b2"
                            },
                            {
                                text: "Blogs and Thought Leaders",
                                value: "a3"
                            },
                            {
                                text: "Online News",
                                value: "c1"
                            },
                            {
                                text: "Traditional News",
                                value: "c2"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--wellness'></div>"
                    },
                    {
                        type: "checkbox",
                        name: "healthPriorities",
                        title: "What are your top health priorities? ",
                        choices: [
                            {
                                text: "Everyday Health",
                                value: "c1"
                            },
                            {
                                text: "Detox and Digestion",
                                value: "c2"
                            },
                            {
                                text: "Muscle Definition, Toning",
                                value: "a1"
                            },
                            {
                                text: "Focus",
                                value: "a2"
                            },
                            {
                                text: "Sports Nutrition",
                                value: "a3"
                            },
                            {
                                text: "Mood",
                                value: "b1"
                            },
                            {
                                text: "Energy",
                                value: "b2"
                            },
                            {
                                text: "Beauty",
                                value: "b3"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--food'></div>"
                    },
                    {
                        type: "radiogroup",
                        name: "afterMeal",
                        title: "How do you feel after a meal?",
                        choices: [
                            {
                                text: "Bloated or gassy",
                                value: "c1"
                            },
                            {
                                text: "Tired / fatigued",
                                value: "c2"
                            },
                            {
                                text: "Satisfied",
                                value: "a"
                            },
                            {
                                text: "Still hungry",
                                value: "b"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--temperature'></div>"
                    },
                    {
                        type: "radiogroup",
                        name: "feelSick",
                        title: "How often do you feel sick?",
                        choices: [
                            {
                                text: "Weekly",
                                value: "c"
                            },
                            {
                                text: "Monthly",
                                value: "b"
                            },
                            {
                                text: "Rarely",
                                value: "a1"
                            },
                            {
                                text: "Almost never",
                                value: "a2"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--sickness'></div>"
                    },
                    {
                        type: "radiogroup",
                        name: "areYouSick",
                        title: "Are you sick right now?",
                        choices: [
                            {
                                text: "Yes",
                                value: "c"
                            },
                            {
                                text: "No",
                                value: "No"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--analytics'></div>"
                    },
                    {
                        type: "radiogroup",
                        name: "biggestHealthGoals",
                        title: "What is your top health goal this year?",
                        choices: [
                            {
                                text: "Weight Loss",
                                value: "b"
                            },
                            {
                                text: "Improving Physical Fitness",
                                value: "a"
                            },
                            {
                                text: "Overall Health and Energy Levels",
                                value: "c"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--weight'></div>"
                    },
                    {
                        type: "radiogroup",
                        name: "consistentProgram",
                        title: "Do you struggle to maintain a consistent nutrition program?",
                        choices: [
                            {
                                text: "Yes",
                                value: "b"
                            },
                            {
                                text: "No",
                                value: "No"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                navigationButtonsVisibility: "hide",
                questions: [
                    {
                        type: "html",
                        name: "info",
                        html: "<input type=\"button\" value=\"Previous\" style=\"margin-right: 10px;\" onclick=\"window.NutritionSurvey.prevPage();\" class=\"btn sv_prev_btn\"><input type=\"button\" value=\"Next\" onclick=\"window.NutritionSurvey.nextPage();\" class=\"btn sv_next_btn\">"
                    },
                    {
                        type: "imagepicker",
                        multiSelect: true,
                        name: "feelMostOften",
                        title: "What do you feel most often? (Pick 3)",
                        choices: [
                            {
                                text: "Happy",
                           		imageLink: "//cdn.shopify.com/s/files/1/0003/8240/2607/t/20/assets/icon-smile_small.png?v=144047994620705759541631638281",
                                value: "a1"
                            },
                            {
                                text: "Excited",
                                imageLink: "//cdn.shopify.com/s/files/1/0003/8240/2607/t/20/assets/icon-excited_small.png?v=145612482526026920051631638271",
                                value: "a2"
                            },
                            {
                                text: "Calm",
                                imageLink: "//cdn.shopify.com/s/files/1/0003/8240/2607/t/20/assets/icon-calm_small.png?v=75884366514918987871631638364",
                                value: "a3"
                            },
                            {
                                text: "Focused",
                                imageLink: "//cdn.shopify.com/s/files/1/0003/8240/2607/t/20/assets/icon-focused_small.png?v=84937449220250921031631638303",
                                value: "a4"
                            },
                            {
                                text: "Tired",
                                imageLink: "//cdn.shopify.com/s/files/1/0003/8240/2607/t/20/assets/icon-tired_small.png?v=107195290872333110161631638309",
                                value: "c1"
                            },
                            {
                                text: "Stressed",
                                imageLink: "//cdn.shopify.com/s/files/1/0003/8240/2607/t/20/assets/icon-stressed_small.png?v=176447120064112743981631638278",
                                value: "c2"
                            },
                            {
                                text: "Overwhelmed",
                                imageLink: "//cdn.shopify.com/s/files/1/0003/8240/2607/t/20/assets/icon-overhelmed_small.png?v=58945927317580112261631638325",
                                value: "c3"
                            },
                            {
                                text: "Apathetic",
                                imageLink: "//cdn.shopify.com/s/files/1/0003/8240/2607/t/20/assets/icon-apathetic_small.png?v=142873499511294172791631638356",
                                value: "c4"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--supplements'></div>"
                    },
                    {
                        type: "radiogroup",
                        name: "willingToAddNewProducts",
                        title: "How willing are you to add new products to your routine?",
                        choices: [
                            {
                                text: "Very",
                                value: "b"
                            },
                            {
                                text: "Moderately",
                                value: "a"
                            },
                            {
                                text: "Not Very",
                                value: "c"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                    {
                        type: "radiogroup",
                        name: "willingToAddNewProducts",
                        title: "What best describes your diet?",
                        choices: [
                            {
                                text: "Paleo",
                                value: "b1"
                            },
                            {
                                text: "Vegan",
                                value: "b2"
                            },
                            {
                                text: "Vegetarian",
                                value: "b3"
                            },
                            {
                                text: "Keto",
                                value: "b4"
                            },
                            {
                                text: "Protein-Forward",
                                value: "a1"
                            },
                            {
                                text: "Healthy and Clean",
                                value: "a2"
                            },
                            {
                                text: "Flexible (I eat most things, in moderation!)",
                                value: "a3"
                            },
                            {
                                text: "Generous (I have fun with my food, even if that includes cheat days!)",
                                value: "c1"
                            },
                            {
                                text: "Quick and easy - I’m busy, so I eat based on what / when I can!",
                                value: "c2"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--network'></div>"
                    },
                    {
                        type: "radiogroup",
                        name: "mostImportantAspect",
                        title: "What do you believe to be the most important aspect of nutrition?",
                        choices: [
                            {
                                text: "Macro-nutrition Intake",
                                value: "a1"
                            },
                            {
                                text: "Supplementation",
                                value: "a2"
                            },
                            {
                                text: "Quality Food vs Processed Food",
                                value: "b1"
                            },
                            {
                                text: "Calorie Count",
                                value: "b2"
                            },
                            {
                                text: "Not Sure",
                                value: "c"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                    {
                        type: "checkbox",
                        name: "eatsMostOften",
                        title: "Which of these do you eat most often on a weekly basis? (Pick 3)",
                        choices: [
                            "Fish",
                            "Red Meat",
                            "Chicken / Turkey",
                            "Veggies",
                            "Fruit",
                            "Dairy",
                            "Junk Food"
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--excersise'></div>"
                    },
                    {
                        type: "radiogroup",
                        name: "howOftenExercise",
                        title: "How often do you exercise each week?",
                        choices: [
                            {
                                text: "Daily",
                                value: "a1"
                            },
                            {
                                text: "4+ Days",
                                value: "a2"
                            },
                            {
                                text: "2-3 Days",
                                value: "b1"
                            },
                            {
                                text: "Maybe 1 Day",
                                value: "b2"
                            },
                            {
                                text: "Infrequently",
                                value: "c1"
                            },
                            {
                                text: "Never",
                                value: "c2"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--lift'></div>"
                    },
                    {
                        type: "radiogroup",
                        name: "howRigorous",
                        title: "How rigorous are your workouts?",
                        choices: [
                            {
                                text: "Low intensity - walk/ yoga/ pilates",
                                value: "c"
                            },
                            {
                                text: "Moderate/Medium intensity - hot yoga/ spin class/ 30-60 minutes of cardio",
                                value: "b"
                            },
                            {
                                text: "Intense - sprints/ weight lifting crossfit/ HIIT",
                                value: "a1"
                            },
                            {
                                text: "Mixed - I vary the intensity levels of my works into a weekly program individualized for my body and goals.",
                                value: "a2"
                            }
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--medicine'></div>"
                    },
                    {
                        type: "radiogroup",
                        name: "useSupplements",
                        title: "Do you currently use any supplements either with training or otherwise?",
                        choices: [
                            "Yes",
                            "No"
                        ],
                        isRequired: true
                    },
                    {
                        type: "text",
                        name: "whichSupplements",
                        title: "If so what are they?"
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--smoke'></div>"
                    },
                    {
                        type: "radiogroup",
                        name: "smoke",
                        title: "Do you smoke?",
                        choices: [
                            "Yes",
                            "No"
                        ],
                        isRequired: true
                    }
                ]
            },
            {
                questions: [
                  	{
                      type: "html",
                      name: "info",
                      html: "<div class='earthbar-survey__icon earthbar-survey__icon--drink'></div>"
                    },
                    {
                        type: "radiogroup",
                        name: "drink",
                        title: "Do you drink?",
                        choices: [
                            "Yes",
                            "No"
                        ],
                        isRequired: true
                    },
                  	{
                        type: "text",
                        name: "howMuchDrinks",
                        title: "How many drinks do you have in a day/week?"
                    }
                ]
            }
        ]
    };

    function flatten(array) {
        return array.reduce(function (flat, toFlatten) {
            return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
        }, []);
    }

    function countResults(array, value) {
        return array.filter(function (item) {
            var cleanItem = item.replace(/[0-9]/g, '');
            return cleanItem === value;
        }).length;
    }

	var wellologyCookieName = "wellologyQuizResult";

	function storeDataInCustomerAccount(result) {

      if($('[data-customer-id]').length) {

        $.cookie(wellologyCookieName, result);

        /*$.ajax({
          type: "POST",
          url: "/admin/customers/" + customerId + "/metafields.json",
          data: {
            "metafield": {
              "key": "earthbarSurveyResults",
              "value": "quiz",
              "namespace": "survey",
              "value_type": "string",
              "description": "User survey result"
            }
          },
          success: function(data) { console.log(data); },
          dataType: "json"
        });*/

      }

    }

    function showRecommendation(result) {

      $('[data-recommendation]').removeClass('visible');
      $('[data-recommendation=' + result + ']').addClass('visible');

    }

    Survey.StylesManager.applyTheme("bootstrap");

    window.NutritionSurvey = new Survey.Model(SurveyModel);

	NutritionSurvey.onUpdateQuestionCssClasses.add(
      function(survey, options) {

        var classes = options.cssClasses;

        if( options.question.getType() === "radiogroup" || options.question.getType() === "checkbox") {
          classes.controlLabel = "earthbar-quiz__label";
        }


      }
    );

    NutritionSurvey.onComplete.add(function (result) {

        var resultData = flatten(Object.values(result.data));
        var finalResults = {
            a: countResults(resultData, "a"),
            b: countResults(resultData, "b"),
            c: countResults(resultData, "c")
        };

      	var highestValue = Object.keys(finalResults).reduce(
                function(a, b){
                    return finalResults[a] > finalResults[b] ? a : b;
                }
            );

        $('[data-survey-element]').hide();
        showRecommendation("x");
        $('[data-recommendation-continue]').on('click', function () {
            showRecommendation(highestValue);
        });

      	storeDataInCustomerAccount(highestValue);
    });

	var wellologyCookie = $.cookie(wellologyCookieName);

	if(wellologyCookie) {

      showRecommendation(wellologyCookie);

    } else {

      $("#surveyElement").Survey({model: NutritionSurvey});

    }

})(Survey);
